import type { FC } from "react";
import React, { memo } from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { ImageControls } from "../image_controls/image_controls";

type Props = {
    description?: string;
    fullscreen?: string; // fullscreen version of img
    handleImageLoaded: any;
    isFullscreen?: boolean;
    onImageError?: any;
    original: string;
    originalAlt?: string;
    originalHeight?: string;
    originalWidth?: string;
    originalTitle?: string;
    sizes?: string;
    srcSet?: string;
};

const ImageItemFC: FC<Props> = ({
    description,
    fullscreen,
    handleImageLoaded,
    isFullscreen,
    onImageError,
    original,
    originalAlt,
    originalHeight,
    originalWidth,
    originalTitle,
    sizes,
    srcSet,
}: Props) => {
    const itemSrc = isFullscreen ? fullscreen || original : original;

    return (
        <>
            <TransformWrapper
                doubleClick={{ disabled: !isFullscreen, step: 0.7 }}
                wheel={{ disabled: !isFullscreen, step: 0.7 }}
            >
                <ImageControls isFullscreen={Boolean(isFullscreen)} />
                <TransformComponent>
                    <img
                        className="image-gallery-image"
                        src={itemSrc}
                        alt={originalAlt}
                        srcSet={srcSet}
                        height={originalHeight}
                        width={originalWidth}
                        sizes={sizes}
                        title={originalTitle}
                        onLoad={(event) => handleImageLoaded(event, original)}
                        onError={onImageError}
                    />
                </TransformComponent>
            </TransformWrapper>
            {description && <span className="image-gallery-description">{description}</span>}
        </>
    );
};

export const ImageItem = memo(ImageItemFC);
